import { createClient } from "@sanity/client";

export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || "oz7z38jm",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  useCdn: true,
  apiVersion: "2024-01-01",
  token: process.env.REACT_APP_SANITY_TOKEN || undefined,
});
